import {Injectable} from '@angular/core';

@Injectable()
export class CommandsIOGamepad {
    constructor() {

    }

    flushJoy() {
    }

    getJoy() {
    }

    joyDown() {
    }

    joyHat() {
    }

    joyHit() {
    }

    joyPitch() {
    }

    joyRoll() {
    }

    joyType() {
    }

    joyU() {
    }

    joyUDir() {
    }

    joyV() {
    }

    joyVDir() {
    }

    joyWait() {
    }

    joyX() {
    }

    joyXDir() {
    }

    joyY() {
    }

    joyYaw() {
    }

    joyYDir() {
    }

    joyZ() {
    }

    joyZDir() {
    }

    waitJoy() {
    }
}
